module.exports = {"pt-BR":{"admin":{"components":{"approvedField":{"label":"Aprovação","values":{"approved":"Aprovado","disapproved":"Reprovado"}}}}}}